import * as React from "react"
import gsap from 'gsap'

class Cursor extends React.Component {
  componentDidMount() {
  	if(document.querySelector('div[data-cursor]')){
  		this.cursorFollow();   
  	}
  }

  cursorFollow() {
  	var cursor = document.querySelector('.floating--cursor');
		var posX = 0,
	  posY = 0;

		var mouseX = 0,
	  mouseY = 0;

	gsap.to({}, 0.016, {
	  repeat: -1,
	  onRepeat: function() {
	    posX += (mouseX - posX) / 9;
	    posY += (mouseY - posY) / 9;

	    gsap.set(cursor, {
	        css: {
	        left: posX - 12,
	        top: posY - 12
	        }
	    });
	  }
	});

	document.addEventListener("mousemove", function(e) {
		mouseX = e.clientX;
		mouseY = e.clientY;
	});
	
  }
  render() {
    return (
      <div className="floating--cursor text-center">
      	<svg width="134" height="134" x="0px" y="0px"  viewBox="0 0 134 134" fill="none">
					<circle cx="67" cy="67" r="66.5" stroke="#FFFFE7" strokeDashoffset="900"/>
				</svg>
				<p className="caption strong"><span className="inner">Explore</span></p>
      </div>
    )
  }
} 

export default Cursor

